import { PrimeIcons } from "primereact/api";
import { Module } from "../../../app_utils/constants/Module";
import { UserSessionUtils } from "../../utils/UserSessionUtils";
import Login from "../../../pages/Login";
import Register from "../../../pages/Register";
import ForgotPassword from "../../../pages/ForgotPassword";
import ResetPassword from "../../../pages/ResetPassword";
import VerifyOtp from "../../../pages/VerifyOtp";
import {
  API_KEYS_ROUTE_PATH,
  APPLICATIONS_ROUTE_PATH,
  BANK_TRANSFER_GATEWAYS_ROUTE_PATH,
  CALLBACKS_ROUTE_PATH,
  COUNTRY_MARKUPS_ROUTE_PATH,
  DATA_BUNDLE_GATEWAYS_ROUTE_PATH,
  DATA_BUNDLE_REPORTS_ROUTE_PATH,
  DATA_BUNDLES_ROUTE_PATH,
  DOCUMENTATION_ROUTE_PATH,
  EMAIL_GATEWAYS_ROUTE_PATH,
  EMAIL_MARKUPS_ROUTE_PATH,
  EMAIL_REPORTS_ROUTE_PATH,
  FORGOT_PASSWORD_ROUTE_PATH,
  GATEWAYS_ROUTE_PATH,
  HOME_ROUTE_PATH,
  LANDING_ROUTE_PATH,
  LOGIN_ROUTE_PATH,
  LOOKUPS_ROUTE_PATH,
  MOBILE_MONEY_GATEWAYS_ROUTE_PATH,
  MONEY_TRANSFERS_ROUTE_PATH,
  MONEY_TRANSFER_REPORTS_ROUTE_PATH,
  PAYMENT_GATEWAYS_ROUTE_PATH,
  PAYMENT_REPORTS_ROUTE_PATH,
  PROFILE_ROUTE_PATH,
  PRODUCTS_ROUTE_PATH,
  REGISTER_ROUTE_PATH,
    RESET_PASSWORD_ROUTE_PATH,
  SEND_SMS_ROUTE_PATH,
  SEND_EMAIL_ROUTE_PATH,
  SMS_REPORTS_ROUTE_PATH,
  SUB_ACCOUNTS_ROUTE_PATH,
  USERS_ROUTE_PATH,
  VERIFY_OTP_ROUTE_PATH,
  WALLET_ROUTE_PATH,
} from "./PageRoutes";
import WalletDeposit from "../../../pages/WalletDeposit";
import MoneyTransfers from "../../../pages/MoneyTransfers";
import MoneyTransferReportsView from "../../../pages/MoneyTransferReportsView";
import Profile from "../../../pages/Profile";
import Dashboard from "../../../pages/Dashboard";
import GatewaysView from "../../../pages/GatewaysView";
import LookupsView from "../../../pages/LookupsView";
import SendSMS from "../../../pages/SendSMS";
import DataBundles from "../../../pages/DataBundles";
import DataBundleReportsView from "../../../pages/DataBundleReportsView";
import SmsReportView from "../../../pages/SmsReportView";
import EmailReportView from "../../../pages/EmailReportView";
import SendEmail from "../../../pages/SendEmail";
import UsersView from "../../../pages/UsersView";
import SubAccountsView from "../../../pages/SubAccountsView";
import ApiKeysView from "../../../pages/ApiKeysView";
import CountryMarkupsView from "../../../pages/CountryMarkupsView";
import Documentation from "../../../pages/Documentation";
import EmailGatewaysView from "../../../pages/EmailGatewaysView";
import PaymentGatewaysView from "../../../pages/PaymentGatewaysView";
import DataBundleGatewaysView from "../../../pages/DataBundleGatewaysView";
import BankTransferGatewaysView from "../../../pages/BankTransferGatewaysView";
import CallbacksView from "../../../pages/CallbacksView";
import MobileMoneyGatewaysView from "../../../pages/MobileMoneyGatewaysView";
import EmailMarkupsView from "../../../pages/EmailMarkupsView";
import PaymentReportView from "../../../pages/PaymentReportView";
import ApplicationsView from "../../../pages/ApplicationsView";
import ProductsView from "../../../pages/ProductsView";
export class MainFrontendRoutes {
  /**
   * Start of module section handler attributes
   */
  settingsModuleSelected = false;
  crmCoreModuleSelected = false;
  documentRepositoryModuleSelected = false;
  userDetails: any = {};
  appHistory: any = null;

  constructor(selectedModuleName: string) {
    this.settingsModuleSelected = selectedModuleName === Module.BACK_OFFICE.toString();
    this.crmCoreModuleSelected = selectedModuleName === Module.CRM_CORE.toString();
    this.documentRepositoryModuleSelected =
      selectedModuleName === Module.DOCUMENT_REPOSITORY.toString();
    this.userDetails = UserSessionUtils.getUserDetails();
  }

  /**
   * This checks whether a user can view the landing page. It checks whether a user has a specific
   * module or set of permissions that are allowed to view the landing page
   * @returns boolean
   */
  userCanViewLandingPage() {
    return true;
  }

  /**
   * From here we populate menu item for the selected module
   */
  getMainNavigationMenu() {
    let menu = [];
    const permissions = this.userDetails?.permissions || [];
    const isSuperAdmin = this.userDetails?.isSuperAdmin;

    const hasPermission = (perm: string) => isSuperAdmin || permissions.includes(perm);

    menu.push({ label: "Home", icon: PrimeIcons.HOME, to: HOME_ROUTE_PATH });
    menu.push({ label: "SMS Reports", icon: PrimeIcons.ENVELOPE, to: SMS_REPORTS_ROUTE_PATH });
    menu.push({ label: "Email Reports", icon: PrimeIcons.ENVELOPE, to: EMAIL_REPORTS_ROUTE_PATH });
    menu.push({ label: "Payment Reports", icon: PrimeIcons.DOLLAR, to: PAYMENT_REPORTS_ROUTE_PATH });
        menu.push({ label: "Send SMS", icon: PrimeIcons.SEND, to: SEND_SMS_ROUTE_PATH });
    menu.push({ label: "Send Email", icon: PrimeIcons.ENVELOPE, to: SEND_EMAIL_ROUTE_PATH });
    menu.push({ label: "Buy Data Bundles", icon: PrimeIcons.TABLET, to: DATA_BUNDLES_ROUTE_PATH });
    menu.push({ label: "Data Bundle Reports", icon: PrimeIcons.LIST, to: DATA_BUNDLE_REPORTS_ROUTE_PATH });
    menu.push({ label: "Wallet", icon: PrimeIcons.WALLET, to: WALLET_ROUTE_PATH });
    menu.push({ label: "Money Transfers", icon: PrimeIcons.MONEY_BILL, to: MONEY_TRANSFERS_ROUTE_PATH });
    menu.push({ label: "Transfer Reports", icon: PrimeIcons.LIST, to: MONEY_TRANSFER_REPORTS_ROUTE_PATH });
    menu.push({ label: "Payment Callbacks", icon: PrimeIcons.SYNC, to: CALLBACKS_ROUTE_PATH });
    if (hasPermission("MANAGE_GATEWAYS")) {
      menu.push({ label: "SMS Gateways", icon: PrimeIcons.COMPASS, to: GATEWAYS_ROUTE_PATH });
    }
    if (hasPermission("MANAGE_GATEWAYS")) {
      menu.push({ label: "Email Gateways", icon: PrimeIcons.ENVELOPE, to: EMAIL_GATEWAYS_ROUTE_PATH });
    }
    if (hasPermission("MANAGE_GATEWAYS")) {
      menu.push({ label: "Payment Gateways", icon: PrimeIcons.WALLET, to: PAYMENT_GATEWAYS_ROUTE_PATH });
    }
    if (hasPermission("MANAGE_GATEWAYS")) {
      menu.push({ label: "Data Bundle Gateways", icon: PrimeIcons.TABLET, to: DATA_BUNDLE_GATEWAYS_ROUTE_PATH });
    }
    if (hasPermission("MANAGE_GATEWAYS")) {
      menu.push({ label: "Bank Transfer Gateways", icon: PrimeIcons.TABLET, to: BANK_TRANSFER_GATEWAYS_ROUTE_PATH });
    }
    if (hasPermission("MANAGE_GATEWAYS")) {
      menu.push({ label: "Mobile Money Gateways", icon: PrimeIcons.TABLET, to: MOBILE_MONEY_GATEWAYS_ROUTE_PATH });
    }
    if (hasPermission("MANAGE_COUNTRY_MARKUPS")) {
      menu.push({ label: "Country Markups", icon: PrimeIcons.MONEY_BILL, to: COUNTRY_MARKUPS_ROUTE_PATH });
    }
    if (hasPermission("MANAGE_COUNTRY_MARKUPS")) {
      menu.push({ label: "Email Markups", icon: PrimeIcons.ENVELOPE, to: EMAIL_MARKUPS_ROUTE_PATH });
    }
    if (hasPermission("ADD_USERS")) {
      menu.push({ label: "System Users", icon: PrimeIcons.USERS, to: USERS_ROUTE_PATH });
    }
    if (hasPermission("ADD_USERS")) {
      menu.push({ label: "Sub Accounts", icon: PrimeIcons.USER_PLUS, to: SUB_ACCOUNTS_ROUTE_PATH });
    }
    menu.push({
      label: "Developer",
      icon: PrimeIcons.CODE,
      items: [
        { label: "API Documentation", icon: PrimeIcons.BOOK, to: DOCUMENTATION_ROUTE_PATH },
        { label: "Products", icon: PrimeIcons.COG, to: PRODUCTS_ROUTE_PATH },
        { label: "API Keys", icon: PrimeIcons.KEY, to: API_KEYS_ROUTE_PATH },
        { label: "Applications", icon: PrimeIcons.SERVER, to: APPLICATIONS_ROUTE_PATH },
      ],
    });
    if (isSuperAdmin) {
      menu.push({ label: "Lookups", icon: PrimeIcons.LIST, to: LOOKUPS_ROUTE_PATH });
    }
    return menu;
  }

  /**
   *
   * @returns
   */
  getUnAuthenticatedRoutes() {
    return [
      { path: LOGIN_ROUTE_PATH, label: "Login", component: Login, exact: true },
      {
        path: REGISTER_ROUTE_PATH,
        label: "Register",
        component: Register,
        exact: true,
      },
      {
        path: FORGOT_PASSWORD_ROUTE_PATH,
        label: "Forgot Password",
        component: ForgotPassword,
        exact: true,
      },
      {
        path: RESET_PASSWORD_ROUTE_PATH,
        label: "Reset Password",
        component: ResetPassword,
        exact: true,
      },
      {
        path: VERIFY_OTP_ROUTE_PATH,
        label: "Verify OTP",
        component: VerifyOtp,
        exact: true,
      },
    ];
  }

  /**
   *
   * @returns
   */
  getAuthenticatedRoutes() {
    let menu = [];
    const permissions = this.userDetails?.permissions || [];
    const isSuperAdmin = this.userDetails?.isSuperAdmin;

    const hasPermission = (perm: string) => isSuperAdmin || permissions.includes(perm);

    menu.push({ path: LOGIN_ROUTE_PATH, component: Login, exact: true });
    menu.push({
      path: HOME_ROUTE_PATH,
      component: Dashboard,
      exact: true,
    });

        menu.push({
      path: SEND_SMS_ROUTE_PATH,
      component: SendSMS,
      exact: true,
    });
    menu.push({
      path: SEND_EMAIL_ROUTE_PATH,
      component: SendEmail,
      exact: true,
    });
    menu.push({
      path: DATA_BUNDLES_ROUTE_PATH,
      component: DataBundles,
      exact: true,
    });
    menu.push({
      path: DATA_BUNDLE_REPORTS_ROUTE_PATH,
      component: DataBundleReportsView,
      exact: true,
    });
    menu.push({
      path: SMS_REPORTS_ROUTE_PATH,
      component: SmsReportView,
      exact: true,
    });
    menu.push({
      path: EMAIL_REPORTS_ROUTE_PATH,
      component: EmailReportView,
      exact: true,
    });
    menu.push({
      path: PAYMENT_REPORTS_ROUTE_PATH,
      component: PaymentReportView,
      exact: true,
    });
    menu.push({
      path: LANDING_ROUTE_PATH,
      component: SendSMS,
      exact: true,
    });
    menu.push({
      path: API_KEYS_ROUTE_PATH,
      component: ApiKeysView,
      exact: true,
    });
    menu.push({
      path: WALLET_ROUTE_PATH,
      component: WalletDeposit,
      exact: true,
    });
    menu.push({
      path: MONEY_TRANSFERS_ROUTE_PATH,
      component: MoneyTransfers,
      exact: true,
    });
    menu.push({
      path: MONEY_TRANSFER_REPORTS_ROUTE_PATH,
      component: MoneyTransferReportsView,
      exact: true,
    });
    menu.push({
      path: CALLBACKS_ROUTE_PATH,
      component: CallbacksView,
      exact: true,
    });
    menu.push({
      path: PROFILE_ROUTE_PATH,
      component: Profile,
      exact: true,
    });

    if (hasPermission("ADD_USERS")) {
      menu.push({
        path: USERS_ROUTE_PATH,
        component: UsersView,
        exact: true,
      });
    }
    if (hasPermission("ADD_USERS")) {
      menu.push({
        path: SUB_ACCOUNTS_ROUTE_PATH,
        component: SubAccountsView,
        exact: true,
      });
    }
    if (hasPermission("MANAGE_GATEWAYS")) {
      menu.push({
        path: GATEWAYS_ROUTE_PATH,
        component: GatewaysView,
        exact: true,
      });
    }
    if (hasPermission("MANAGE_GATEWAYS")) {
      menu.push({
        path: EMAIL_GATEWAYS_ROUTE_PATH,
        component: EmailGatewaysView,
        exact: true,
      });
    }
    if (hasPermission("MANAGE_GATEWAYS")) {
      menu.push({
        path: PAYMENT_GATEWAYS_ROUTE_PATH,
        component: PaymentGatewaysView,
        exact: true,
      });
    }
    if (hasPermission("MANAGE_GATEWAYS")) {
      menu.push({
        path: DATA_BUNDLE_GATEWAYS_ROUTE_PATH,
        component: DataBundleGatewaysView,
        exact: true,
      });
    }
    if (hasPermission("MANAGE_GATEWAYS")) {
      menu.push({
        path: BANK_TRANSFER_GATEWAYS_ROUTE_PATH,
        component: BankTransferGatewaysView,
        exact: true,
      });
    }
    if (hasPermission("MANAGE_GATEWAYS")) {
      menu.push({
        path: MOBILE_MONEY_GATEWAYS_ROUTE_PATH,
        component: MobileMoneyGatewaysView,
        exact: true,
      });
    }
    if (hasPermission("MANAGE_COUNTRY_MARKUPS")) {
      menu.push({
        path: COUNTRY_MARKUPS_ROUTE_PATH,
        component: CountryMarkupsView,
        exact: true,
      });
    }
    if (hasPermission("MANAGE_COUNTRY_MARKUPS")) {
      menu.push({
        path: EMAIL_MARKUPS_ROUTE_PATH,
        component: EmailMarkupsView,
        exact: true,
      });
    }
    menu.push({
      path: DOCUMENTATION_ROUTE_PATH,
      component: Documentation,
      exact: true,
    });
    menu.push({
      path: PRODUCTS_ROUTE_PATH,
      component: ProductsView,
      exact: true,
    });
    menu.push({
      path: APPLICATIONS_ROUTE_PATH,
      component: ApplicationsView,
      exact: true,
    });
    if (isSuperAdmin) {
      menu.push({
        path: LOOKUPS_ROUTE_PATH,
        component: LookupsView,
        exact: true,
      });
    }
    return menu;
  }
}
